var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sa-page-layout',{attrs:{"viewFilterSection":false,"btnBackVisible":false,"linkback":_vm.linkback,"linkedit":_vm.linkedit,"pathResource":_vm.pathResource,"showModalLoading":_vm.showModalLoading}},[_c('template',{slot:"table-body"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }